import { useCallback, useEffect, useMemo } from 'react';

import { Portal } from 'api/portals/requests';

export const usePortalSelection = (
  portals: Portal[] | undefined,
  selectedPortalIds: string[],
  setSelectedPortalIds: (ids: string[]) => void,
) => {
  useEffect(() => {
    if (!portals) return;

    const availableIds = new Set(portals.map((p) => p.shortId));
    const filtered = selectedPortalIds.filter((id) => availableIds.has(id));
    if (filtered.length !== selectedPortalIds.length) {
      setSelectedPortalIds(filtered);
    }
  }, [portals, selectedPortalIds, setSelectedPortalIds]);

  const selectedPortalNames = useMemo(
    () =>
      selectedPortalIds
        .map((id) => portals?.find((portal) => portal.shortId === id)?.name)
        .filter(Boolean) as string[],
    [selectedPortalIds, portals],
  );

  const handleCheckboxGroupChange = useCallback(
    (selectedNames: string[]) => {
      const selectedIds = selectedNames
        .map((name) => portals?.find((portal) => portal.name === name)?.shortId)
        .filter(Boolean) as string[];
      setSelectedPortalIds(selectedIds);
    },
    [portals, setSelectedPortalIds],
  );

  return {
    selectedPortalNames,
    handleCheckboxGroupChange,
  };
};
